import { IConfig } from '@cian/config/shared';

const PROMO_URL_CONFIG_KEY = 'mortgage-calculator.cianMortgagePromoUrl';

export const getCianMortgagePromoUrl = (config: IConfig): string => {
  return config.get<string>(PROMO_URL_CONFIG_KEY) ?? '';
};
